/**
 * Cookie-auth support: the backend authenticates via an httpOnly cookie
 * (no token in JavaScript), so every request to the API must be sent with
 * credentials. Wrapping fetch once here covers all service files without
 * touching each call site.
 */

import { API_CONFIG } from '../config/api.config';

const originalFetch = window.fetch.bind(window);

window.fetch = ((input: RequestInfo | URL, init?: RequestInit) => {
  const url =
    typeof input === 'string' ? input : input instanceof URL ? input.href : input.url;

  if (url.startsWith(API_CONFIG.BASE_URL)) {
    return originalFetch(input, { credentials: 'include', ...init } as RequestInit);
  }
  return originalFetch(input, init);
}) as typeof window.fetch;

export {};
